// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/truck_events.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Truck, TruckStatus } from "./truck_pb.js";
import { file_transportation_v1_truck } from "./truck_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/truck_events.proto.
 */
export const file_transportation_v1_truck_events: GenFile = /*@__PURE__*/
  fileDesc("CiR0cmFuc3BvcnRhdGlvbi92MS90cnVja19ldmVudHMucHJvdG8SEXRyYW5zcG9ydGF0aW9uLnYxIoYCCgpUcnVja0V2ZW50EjcKB2NyZWF0ZWQYASABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5UcnVja0NyZWF0ZWRFdmVudEgAEjcKB3VwZGF0ZWQYAiABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5UcnVja1VwZGF0ZWRFdmVudEgAEjcKB2RlbGV0ZWQYAyABKAsyJC50cmFuc3BvcnRhdGlvbi52MS5UcnVja0RlbGV0ZWRFdmVudEgAEkQKDnN0YXR1c19jaGFuZ2VkGAQgASgLMioudHJhbnNwb3J0YXRpb24udjEuVHJ1Y2tTdGF0dXNDaGFuZ2VkRXZlbnRIAEIHCgVldmVudCI8ChFUcnVja0NyZWF0ZWRFdmVudBInCgV0cnVjaxgBIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlRydWNrInYKEVRydWNrVXBkYXRlZEV2ZW50EjAKDnByZXZpb3VzX3RydWNrGAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuVHJ1Y2sSLwoNdXBkYXRlZF90cnVjaxgCIAEoCzIYLnRyYW5zcG9ydGF0aW9uLnYxLlRydWNrIjwKEVRydWNrRGVsZXRlZEV2ZW50EicKBXRydWNrGAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuVHJ1Y2sirwEKF1RydWNrU3RhdHVzQ2hhbmdlZEV2ZW50EicKBXRydWNrGAEgASgLMhgudHJhbnNwb3J0YXRpb24udjEuVHJ1Y2sSNwoPcHJldmlvdXNfc3RhdHVzGAIgASgOMh4udHJhbnNwb3J0YXRpb24udjEuVHJ1Y2tTdGF0dXMSMgoKbmV3X3N0YXR1cxgDIAEoDjIeLnRyYW5zcG9ydGF0aW9uLnYxLlRydWNrU3RhdHVzQkFaP3BhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLXRyYW5zcG9ydGF0aW9uL2FwaS92MTt0cmFuc3BvcnRhdGlvbl92MWIIZWRpdGlvbnNw6Ac", [file_transportation_v1_truck]);

/**
 * @generated from message transportation.v1.TruckEvent
 */
export type TruckEvent = Message<"transportation.v1.TruckEvent"> & {
  /**
   * @generated from oneof transportation.v1.TruckEvent.event
   */
  event: {
    /**
     * @generated from field: transportation.v1.TruckCreatedEvent created = 1;
     */
    value: TruckCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: transportation.v1.TruckUpdatedEvent updated = 2;
     */
    value: TruckUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: transportation.v1.TruckDeletedEvent deleted = 3;
     */
    value: TruckDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: transportation.v1.TruckStatusChangedEvent status_changed = 4;
     */
    value: TruckStatusChangedEvent;
    case: "statusChanged";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message transportation.v1.TruckEvent.
 * Use `create(TruckEventSchema)` to create a new message.
 */
export const TruckEventSchema: GenMessage<TruckEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck_events, 0);

/**
 * @generated from message transportation.v1.TruckCreatedEvent
 */
export type TruckCreatedEvent = Message<"transportation.v1.TruckCreatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Truck truck = 1;
   */
  truck?: Truck;
};

/**
 * Describes the message transportation.v1.TruckCreatedEvent.
 * Use `create(TruckCreatedEventSchema)` to create a new message.
 */
export const TruckCreatedEventSchema: GenMessage<TruckCreatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck_events, 1);

/**
 * @generated from message transportation.v1.TruckUpdatedEvent
 */
export type TruckUpdatedEvent = Message<"transportation.v1.TruckUpdatedEvent"> & {
  /**
   * @generated from field: transportation.v1.Truck previous_truck = 1;
   */
  previousTruck?: Truck;

  /**
   * @generated from field: transportation.v1.Truck updated_truck = 2;
   */
  updatedTruck?: Truck;
};

/**
 * Describes the message transportation.v1.TruckUpdatedEvent.
 * Use `create(TruckUpdatedEventSchema)` to create a new message.
 */
export const TruckUpdatedEventSchema: GenMessage<TruckUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck_events, 2);

/**
 * @generated from message transportation.v1.TruckDeletedEvent
 */
export type TruckDeletedEvent = Message<"transportation.v1.TruckDeletedEvent"> & {
  /**
   * @generated from field: transportation.v1.Truck truck = 1;
   */
  truck?: Truck;
};

/**
 * Describes the message transportation.v1.TruckDeletedEvent.
 * Use `create(TruckDeletedEventSchema)` to create a new message.
 */
export const TruckDeletedEventSchema: GenMessage<TruckDeletedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck_events, 3);

/**
 * @generated from message transportation.v1.TruckStatusChangedEvent
 */
export type TruckStatusChangedEvent = Message<"transportation.v1.TruckStatusChangedEvent"> & {
  /**
   * @generated from field: transportation.v1.Truck truck = 1;
   */
  truck?: Truck;

  /**
   * @generated from field: transportation.v1.TruckStatus previous_status = 2;
   */
  previousStatus: TruckStatus;

  /**
   * @generated from field: transportation.v1.TruckStatus new_status = 3;
   */
  newStatus: TruckStatus;
};

/**
 * Describes the message transportation.v1.TruckStatusChangedEvent.
 * Use `create(TruckStatusChangedEventSchema)` to create a new message.
 */
export const TruckStatusChangedEventSchema: GenMessage<TruckStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_transportation_v1_truck_events, 4);

